import { useEffect } from 'react';

export const useSwiperInit = () => {
  useEffect(() => {
    const initSwiper = () => {
      if (typeof window !== 'undefined' && (window as any).Swiper) {
        const Swiper = (window as any).Swiper;
        
        console.log('🔄 Inicializando Swiper...');

        new Swiper('.hero-slider .swiper-container', {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          speed: 800,
          effect: 'fade',
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-cust-pagination',
            clickable: true,
            renderBullet: function (index: number, className: string) {
              const bullets = [
                { icon: 'fi flaticon-dog', text: 'Family Law plan', title: 'Family Law' },
                { icon: 'fi flaticon-wounded', text: 'Personal injury plan', title: 'Personal Injury' },
                { icon: 'fi flaticon-thief', text: 'Criminal plan', title: 'Criminal Law' },
                { icon: 'fi flaticon-save-money', text: 'Business law plan', title: 'Business Law' }
              ];
              return `
                <div class="${className}">
                  <i class="${bullets[index].icon}"></i>
                  ${bullets[index].text}
                  <h4>${bullets[index].title}</h4>
                </div>
              `;
            },
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          parallax: true,
          on: {
            init: function () {
              console.log('✅ Swiper inicializado CORRECTAMENTE');
            }
          }
        });
      } else {
        setTimeout(initSwiper, 100);
      }
    };

    const timer = setTimeout(initSwiper, 500);

    return () => {
      clearTimeout(timer);
    };
  }, []);
};